<template>
  <DiscountPassVerification
    :handle-submit-error="handleSubmitError"
    :validation-params="validationParams"
    :show-form-level-error-message="false"
    :disable-submit="!validationParams.validationString"
    v-on="$listeners"
  >
    <div
      slot="summary"
      class="info"
    >
      <h2 class="legend">
        Verify Eligibility
      </h2>
      <p>Enter your PA Access Card number to verify that you are eligible for a discounted pass.</p>
    </div>
    <template slot="eligibility-fields">
      <Input
        id="access-card"
        v-model="validationParams.validationString"
        label="ACCESS Card Number"
        :error="errorMessage"
        name="access-card"
        type="text"
        inputmode="numeric"
        autocapitalize="off"
        autocorrect="off"
        mask="XXXXXX XXXXXXXXXX XX X"
        required
      />
    </template>
    <div
      slot="details"
      class="info"
    >
      <p>Your PA ACCESS Card cannot be used to pay for your Indego Pass. Entering your number will only verify that you are eligible for this pass type. Payment must be made using a credit card.</p>
      <p>Up to four family members of the same household are eligible to sign up with the same ACCESS card.</p>
      <p>
        We respect your privacy! Your PA ACCESS Card number will not be shared or used for any reason other than to check your eligibility. For any questions, please call or text our help desk at
        <a href="tel:+18444463346">(844) 446-3346</a> or email
        <a href="mailto:support@rideindego.com">support@rideindego.com</a>.
      </p>
    </div>
  </DiscountPassVerification>
</template>

<script>
import Input from '../../Input.vue';
import DiscountPassVerification from '../DiscountPassVerification.vue';

export default {
  components: { Input, DiscountPassVerification },
  data() {
    return {
      errorMessage: undefined,
      validationParams: {
        validationType: 'access_card',
        validationString: '',
      },
    };
  },
  methods: {
    handleSubmitError(errorMessage = 'The ACCESS card entered is invalid or expired. Please try again.') {
      this.errorMessage = errorMessage;
    },
  },
};
</script>
